// Leaflet base CSS (bundled separately so it only loads on the place archive).
import 'leaflet/dist/leaflet.css';

import { initPlacesMap } from './modules/places-map.js';

document.addEventListener( 'DOMContentLoaded', () => {
	initPlacesMap();
} );
